import * as React from "react"
import ReminderNotification from "../../model/notification/reminder/ReminderNotification";
import {toast} from "react-toastify";
import NotificationToast from "../notification/NotificationToast";
import DefaultToast from "../notification/DefaultToast";
import {NotificationType} from "../../model/notification/NotificationBase";

export interface ToastOptions {
	position?: string,
	autoClose?: false | number,
	closeButton?: React.Component | false,
	hideProgressBar?: boolean,
	pauseOnHover?: boolean,
	closeOnClick?: boolean,
	newestOnTop?: boolean,
	className?: string | {},
	style?: {},
	toastClassName?: string | {},
	bodyClassName?: string | {},
	progressClassName?: string | {}
}

/**
 * Toasts factory.
 */
export default class Toast {

	static toastIdMap: {[notificationId: string]: number} = {};

	static defaultNotificationOptions: ToastOptions = {
		autoClose: false,
		className: "info"
	};

	static defaultToastOptions: ToastOptions = {
		autoClose: 5000,
		hideProgressBar: true
	};

	/**
	 * Show error toast.
	 * @param {string} body body text of the toast.
	 * @param {string} title title text of the toast.
	 * @param {ToastOptions} options to use to show toast.
	 */
	static error(body: string, title?: string, options?: ToastOptions) {
		const toastOptions = options ? {...options, className: "danger"} : {...this.defaultToastOptions, className: "danger"};
		toast(<DefaultToast title={title} body={body} icon={"times-circle"}/>, toastOptions);
	}

	/**
	 * Show info toast.
	 * @param {string} body body text of the toast.
	 * @param {string} title title text of the toast.
	 * @param {ToastOptions} options to use to show toast.
	 */
	static info(body: string, title?: string, options?: ToastOptions) {
		const toastOptions = options ? {...options, className: "info"} : {...this.defaultToastOptions, className: "info"};
		toast(<DefaultToast title={title} body={body} icon={"info-circle"}/>, toastOptions);
	}

	/**
	 * Show success toast.
	 * @param {string} body body text of the toast.
	 * @param {string} title title text of the toast.
	 * @param {ToastOptions} options to use to show toast.
	 */
	static success(body: string, title?: string, options?: ToastOptions) {
		const toastOptions = options ? {...options, className: "success"} : {...this.defaultToastOptions, className: "success"};
		toast(<DefaultToast title={title} body={body} icon={"check-circle"}/>, toastOptions);
	}

	/**
	 * Show warning toast.
	 * @param {string} body body text of the toast.
	 * @param {string} title title text of the toast.
	 * @param {ToastOptions} options to use to show toast.
	 */
	static warning(body: string, title?: string, options?: ToastOptions) {
		const toastOptions = options ? {...options, className: "warning"} : {...this.defaultToastOptions, className: "warning"};
		toast(<DefaultToast title={title} body={body} icon={"exclamation-triangle"}/>, toastOptions);
	}

	/**
	 * Warning notify.
	 * @param {ReminderNotification} notification Notification to show.
	 * @param {ToastOptions} options to use to show toast.
	 */
	public static notification(notification: NotificationType, options?: ToastOptions) {
		const toastOptions = options ? {...options, ...this.defaultNotificationOptions} : {...this.defaultNotificationOptions};
		this.toastIdMap[notification.id] = toast(<NotificationToast notification={notification}/>, toastOptions);
	}

	/**
	 * Dismiss toast related to notification.
	 * @param {string} notificationId
	 */
	static dismiss(notificationId: string) {
		toast.dismiss(Toast.toastIdMap[notificationId]);
	}
}